'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, useState, type PropsWithChildren } from 'react';
export const ScrollableContext = createContext<{
  isScrolledVertically: boolean;
  setIsScrolledVertically: (isScrolledVertically: boolean) => void;
} | null>(null);
export const ScrollableWrapper = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  const [isScrolledVertically, setIsScrolledVertically] = useState(false);
  let t1;
  if ($[0] !== isScrolledVertically) {
    t1 = {
      isScrolledVertically,
      setIsScrolledVertically
    };
    $[0] = isScrolledVertically;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <ScrollableContext.Provider value={t1}>{children}</ScrollableContext.Provider>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};